import { FC } from 'react'
import { Box, ColumnLayout, SpaceBetween } from '@cloudscape-design/components'
import useSingleTags from '../../../hooks/query/useSingleTags'
import LoadingSpinner from '../../LoadingSpinner'
import ApproverOverview from '../ApproverOverview'
import { keysToLabel } from '../../../helper/toCamelCase'

interface ReadGenericTagsProps {
	tagsId: string
	layout?: number
	isApprovalDisabled?: boolean
}

const ReadGenericTags: FC<ReadGenericTagsProps> = ({
	tagsId,
	layout = 2,
	isApprovalDisabled = true
}) => {
	const { data: originalTags, isLoading: isLoadingTags } = useSingleTags(tagsId)

	if (!originalTags || isLoadingTags) return <LoadingSpinner />

	const tagKeys = Object.keys(originalTags['details']) || []
	const getLabel = (tagkey: string) => {
		switch (tagkey) {
			case 'tagProject':
				return 'Project'
			case 'WBSCode':
			case 'W B S Code':
				return 'WBS Code'
			default:
				return keysToLabel(tagkey)
		}
	}
	/** Safely render detail value: may be string or { value, label } */
	const formatDetailValue = (val: unknown): string => {
		if (val == null || val === '') return 'NA'
		if (typeof val === 'object' && val !== null && ('value' in val || 'label' in val)) {
			const o = val as { value?: string; label?: string }
			return o.label ?? o.value ?? 'NA'
		}
		return String(val)
	}
	return (
		<>
			<SpaceBetween direction="vertical" size="s">
				<ColumnLayout columns={layout} variant="text-grid">
					{tagKeys?.map((tagkey) => (
						<div key={tagkey}>
							<Box variant="awsui-key-label">{getLabel(tagkey)}</Box>
							{formatDetailValue(originalTags['details'][tagkey])}
						</div>
					))}
				</ColumnLayout>
				<ApproverOverview
					approvalStatus={originalTags['approvalStatus']}
					isDisabled={isApprovalDisabled}
				/>
			</SpaceBetween>
		</>
	)
}

export default ReadGenericTags
